import {
  TBookedOfferRecommendationsActions,
  EBookedOfferRecommendationsActionTypes,
} from '../../actions/bookedOfferRecommendations';
import { IRecomendedOfferSchema } from '../../types/recommendedOffer';

const DEFAULT_STATE: IRecomendedOfferSchema[] = [];

export const bookedOfferRecommendationsReducer = (
  state: IRecomendedOfferSchema[] = DEFAULT_STATE,
  action: TBookedOfferRecommendationsActions,
): IRecomendedOfferSchema[] => {
  switch (action.type) {
    case EBookedOfferRecommendationsActionTypes.SetBookedOfferRecommendations:
      return action.payload;

    default:
      return state;
  }
};
